/**
 * Category badge colors for collection cards and filters.
 * Uses explicit hex values so badges stay visible on pastel card backgrounds
 * and are not dropped by Tailwind's class scanner.
 */
export interface CategoryBadgeStyle {
  backgroundColor: string;
  color: string;
}

export const categoryBadgeStyles: Record<string, CategoryBadgeStyle> = {
  "All Collections": { backgroundColor: "#2563eb", color: "#ffffff" },
  Math: { backgroundColor: "#2563eb", color: "#ffffff" },
  "Language Arts": { backgroundColor: "#15803d", color: "#ffffff" },
  "Number Sense": { backgroundColor: "#7c3aed", color: "#ffffff" },
  Science: { backgroundColor: "#a16207", color: "#ffffff" },
  Nursing: { backgroundColor: "#dc2626", color: "#ffffff" },
  "Domino Comparison": { backgroundColor: "#c2410c", color: "#ffffff" },
  "Picture Quiz": { backgroundColor: "#a21caf", color: "#ffffff" },
  "Picture Words": { backgroundColor: "#0369a1", color: "#ffffff" },
  Uncategorized: { backgroundColor: "#4b5563", color: "#ffffff" },
};

export const getCategoryBadgeStyle = (category: string): CategoryBadgeStyle =>
  categoryBadgeStyles[category] ?? categoryBadgeStyles.Uncategorized;

/** @deprecated Use getCategoryBadgeStyle for inline styles instead. */
export const categoryColors = {
  "All Collections": "bg-blue-500",
  Math: "bg-blue-500",
  "Language Arts": "bg-green-500",
  "Number Sense": "bg-purple-500",
  Science: "bg-yellow-500",
  Nursing: "bg-red-500",
  "Domino Comparison": "bg-orange-500",
  "Picture Quiz": "bg-fuchsia-700",
  "Picture Words": "bg-sky-700",
  Uncategorized: "bg-gray-500",
} as const;
